export type VersaoModel = {
    numero: string
    data: string
    alteracoes: string[]
}

export type HistoricoVersoesModel = {
    versaoAtual: string
    versoes: VersaoModel[]
}

// O texto de cada alteração é renderizado como HTML (ListaVersoes usa dangerouslySetInnerHTML),
// então <strong> funciona. Escreva para o fornecedor, não para quem programou: o que mudou na
// tela dele, não como foi feito.
export const HistoricoVersoesInicial: HistoricoVersoesModel = {
    versaoAtual: "5.8.4",
    versoes: [
        {
            numero: "5.8.4",
            data: "04/09/2026",
            alteracoes: [
                "<strong>Painel de Pedidos</strong>: o botão <strong>Atualizar</strong> agora recarrega os pedidos direto da fonte, ignorando qualquer cópia temporária. Isso corrige, na hora, casos raros em que um pedido pago não aparecia na lista (ficava preso com uma situação antiga) — antes ele só voltaria a aparecer sozinho depois de um tempo.",
            ],
        },
        {
            numero: "5.6.0",
            data: "25/08/2026",
            alteracoes: [
                "<strong>Painel de Pedidos</strong>: as colunas foram reorganizadas por situação do pedido — <strong>Aceito</strong> (junta os que estão aguardando aceitação e os já aceitos), <strong>Em Preparação</strong>, <strong>Em Entrega</strong> e <strong>Finalizado</strong>. Um pedido pago ou parcialmente pago passa a aparecer em <strong>Finalizado</strong>.",
                "<strong>Preparo automático</strong>: quando um pedido não avança sozinho e fica parado, agora aparece um <strong>aviso no topo da tela</strong> listando esses pedidos, com a opção de prepará-los manualmente — antes eles podiam ficar sem aparecer. O sistema também volta a tentar processá-los automaticamente.",
            ],
        },
        {
            numero: "5.5.4",
            data: "21/08/2026",
            alteracoes: [
                "<strong>Pedidos em tempo real</strong>: corrigido um caso em que o <strong>som de novo pedido tocava, mas o pedido só aparecia na lista cerca de 1 minuto depois</strong>. Agora, assim que o aviso sonoro toca, o pedido é carregado e exibido na hora, sem esperar a atualização periódica.",
            ],
        },
        {
            numero: "5.5.3",
            data: "21/08/2026",
            alteracoes: [
                "<strong>Impressão</strong>: melhorias internas de diagnóstico para investigar casos de <strong>comanda duplicada</strong> quando o sistema fica aberto em mais de uma janela na mesma estação. Não altera o funcionamento — apenas registra mais detalhes para localizar a causa.",
            ],
        },
        {
            numero: "5.5.2",
            data: "20/08/2026",
            alteracoes: [
                "<strong>Registrador de pedidos</strong>: novo botão <strong>Limpar pedido</strong>, abaixo do botão Finalizar, para remover todos os itens do pedido em andamento (pede confirmação antes).",
                "<strong>Impressão</strong>: corrigida uma situação em que a comanda podia sair duplicada na mesma estação quando a impressão automática coincidia com a verificação periódica de segurança.",
            ],
        },
        {
            numero: "5.5.1",
            data: "20/08/2026",
            alteracoes: [
                "<strong>Registrador de pedidos</strong>: ajuste visual na barra de busca do cardápio — o campo de busca, <strong>Tipo pedido</strong> e <strong>Categoria</strong> agora ficam na mesma linha quando há espaço na tela, e a engrenagem de configurações passou para o final da barra.",
            ],
        },
        {
            numero: "5.5.0",
            data: "20/08/2026",
            alteracoes: [
                "<strong>Caixa</strong>: corrigido o valor mostrado ao clicar para <strong>ver o pedido de uma mesa</strong> na listagem de pagamentos — em alguns casos aparecia um total diferente do valor da linha, somando um pedido de outro fechamento da mesa.",
                "<strong>Histórico de Mesas</strong>: novo atalho na listagem para abrir a mesa direto no <strong>Gerenciador de Mesas</strong>.",
                "<strong>Registrador de pedidos</strong>: o filtro de categorias do cardápio agora pode ser trocado de <strong>botões</strong> (padrão) para <strong>caixa de seleção</strong>, pela engrenagem de configurações da tela.",
            ],
        },
        {
            numero: "5.4.1",
            data: "20/08/2026",
            alteracoes: [
                "<strong>Som de novo pedido</strong>: ao clicar em <strong>Aceitar</strong> ou <strong>Preparar</strong> em uma aba, o alerta sonoro agora <strong>para em todas as abas</strong> do navegador — antes silenciava só na aba em que você clicou e as demais continuavam tocando.",
                "<strong>Configurações entre abas</strong>: o <strong>tipo de operação</strong> (Automática, Manual, Visualização, Garçom), a <strong>duração do alerta sonoro</strong> e as demais configurações agora <strong>valem para todas as abas</strong> do navegador na hora. Antes era preciso ajustar em cada aba.",
                "<strong>Impressões do Dia</strong>: nova tela em <strong>Administração &gt; Utilitários</strong> que lista todas as impressões enviadas para a loja no dia (hora do envio, pedido e tipo de impressão), com <strong>filtro por dia</strong>.",
            ],
        },
        {
            numero: "5.4.0",
            data: "20/08/2026",
            alteracoes: [
                "<strong>Registrador de pedidos</strong>: agora dá para <strong>ajustar a largura do carrinho</strong> — arraste a borda esquerda do painel do carrinho para deixá-lo mais estreito ou mais largo, conforme a sua tela. O tamanho escolhido fica salvo naquele computador.",
                "<strong>Mesas</strong>: ao tocar em <strong>Reimprimir</strong> a comanda de uma rodada, o sistema agora pede uma <strong>confirmação</strong> antes de reenviar, evitando reimpressões acidentais. A comanda continua saindo na <strong>estação da loja</strong>, não no aparelho.",
            ],
        },
        {
            numero: "5.3.0",
            data: "19/08/2026",
            alteracoes: [
                "<strong>Modo Garçom</strong>: novo modo de operação, ao lado de <strong>Automática</strong>, <strong>Manual</strong> e <strong>Visualização</strong>. No <strong>Garçom</strong> o aparelho vira um terminal só de lançamento — não recebe pedidos em tempo real, não toca, não imprime e não fica online no painel. Ideal para o <strong>celular do garçom</strong>: ele lança o pedido e a comanda sai na <strong>estação da loja</strong>. É ativado automaticamente em celulares sem impressora (QZ), e você pode trocar o modo a qualquer momento no seletor de <strong>Operação</strong>.",
                "<strong>Mesas</strong>: cada rodada de pedidos da mesa ganhou um botão <strong>Reimprimir</strong>. Se a comanda de um item adicionado não sair na impressora, dá para reenviá-la manualmente pela estação da loja.",
            ],
        },
        {
            numero: "5.2.3",
            data: "19/08/2026",
            alteracoes: [
                "<strong>Mesas</strong>: na tela de fechar a mesa no celular, os botões <strong>Cancelar</strong>, <strong>Imprimir</strong> e <strong>Fechar</strong> não ficam mais escondidos atrás dos botões <strong>Detalhes da mesa</strong> e <strong>Adicionar pedido</strong>.",
                "<strong>Mesas</strong>: ao abrir o fechamento de uma mesa ainda sem pedidos, os valores (Subtotal, Taxa, Total e Valor Restante) aparecem como <strong>R$ 0,00</strong> em vez de <strong>NaN</strong>.",
                "<strong>Som de novo pedido</strong>: agora só a estação em <strong>Operação</strong> toca o alerta. Aparelhos em <strong>Visualização</strong> (ex.: o celular do garçom) ficam <strong>mudos</strong> — o som sai apenas na estação de recebimento (o computador). Antes, um aparelho em Visualização também tocava.",
            ],
        },
        {
            numero: "5.2.2",
            data: "19/08/2026",
            alteracoes: [
                "<strong>Aceite automático</strong>: corrigido um caso em que pedidos deixavam de ser aceitos e acabavam expirando quando havia mais de uma aba/janela do painel aberta — a rede de segurança volta a reofertar o aceite mesmo quando a aba que mantém a conexão não é a do Painel, e a marca do aceite é liberada em caso de falha para a próxima tentativa não ficar travada.",
                "<strong>Impressão</strong>: garantido que a correção de duplicidade das comandas do iFood não interfira na impressão de itens adicionados a uma mesa (cada rodada de itens da mesa imprime normalmente).",
            ],
        },
        {
            numero: "5.2.1",
            data: "19/08/2026",
            alteracoes: [
                "<strong>Impressão (iFood)</strong>: corrigida a impressão em duplicidade da comanda de pedidos do iFood quando o aceite automático está ligado — agora sai apenas uma via por estação.",
                "<strong>Registrador de pedidos</strong>: ao adicionar um item, o sistema volta a perguntar a quantidade e a observação numa tela final. Isso pode ser ligado ou desligado na engrenagem de configurações da tela (por padrão, ligado).",
            ],
        },
        {
            numero: "5.2.0",
            data: "19/08/2026",
            alteracoes: [
                "<strong>Registrador de pedidos</strong>: vários ajustes visuais e de uso na tela — o carrinho continua salvo se você fechar ou recarregar a página (o pedido em andamento não se perde), o botão de finalizar fica sempre visível com a rolagem apenas na lista de itens, e o layout ficou melhor no celular e no popup de opções.",
                "<strong>Registrador de pedidos</strong>: na busca, ao informar o código de um tamanho/opção o item já entra pronto no carrinho; e dá para informar a quantidade junto (ex.: <strong>2*codigo</strong> adiciona 2 unidades).",
                "<strong>Cadastro de produto</strong>: o preço deixou de ser obrigatório na edição.",
            ],
        },
        {
            numero: "5.1.1",
            data: "18/08/2026",
            alteracoes: [
                "<strong>Mesas</strong>: ao fechar a mesa (tanto no fechamento total quanto no parcial), o sistema agora pergunta se você deseja imprimir. Respondendo <strong>Sim</strong>, o comprovante é impresso; respondendo <strong>Não</strong>, a mesa é fechada sem imprimir.",
            ],
        },
        {
            numero: "5.1.0",
            data: "18/08/2026",
            alteracoes: [
                "<strong>Pedidos expirados</strong>: corrigido o comportamento de pedidos expirados quando o aceite automático está ligado.",
                "<strong>Painel</strong>: pedidos ainda não pagos deixam de aparecer no painel.",
                "<strong>Registrador de pedidos</strong>: ajuste visual — o carrinho fica sempre visível.",
                "<strong>Mesas</strong>: validação que impede a edição de uma mesa já fechada.",
            ],
        },
        {
            numero: "5.0.0",
            data: "01/08/2026",
            alteracoes: [
                "<strong>Aceite e impressão automáticos</strong>: agora é possível aceitar e imprimir pedidos com qualquer tela do painel aberta, não apenas a de receber pedidos.",
            ],
        },
        {
            numero: "4.0.0",
            data: "16/07/2026",
            alteracoes: [
                "<strong>IA do Cardápio</strong>: corrigido o erro que impedia o uso em cardápios grandes. Antes, o comando falhava com a mensagem \"A IA não retornou resposta\" porque o cardápio inteiro era enviado de uma vez e excedia o limite da IA. Agora o sistema identifica a parte do cardápio relacionada ao seu comando e envia apenas ela — o que também deixou a resposta mais rápida.",
                "<strong>IA do Cardápio</strong>: quando algo dá errado, a tela passa a mostrar o motivo real da falha, em vez de uma mensagem genérica.",
                "<strong>IA do Cardápio</strong>: em cardápios grandes, o sistema agora orienta a citar a categoria no comando (ex.: \"Na categoria Esfihas, ...\") para um resultado melhor e mais rápido.",
            ],
        },
    ],
}
